import React from 'react';
import { Provider } from 'react-redux';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { createBrowserRouter, ScrollRestoration } from 'react-router-dom';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { OverlayProvider } from '@uhg-abyss/web/ui/OverlayProvider';
import { RouterProvider } from '@uhg-abyss/web/ui/RouterProvider';
import { I18nProvider } from '@uhg-abyss/web/ui/I18nProvider';
import { AuthProvider } from './auth';
import { Routes } from './routes';
import { store } from '@src/store/reduxStore';

const theme = createTheme('uhc');

// Abyss's createRouter switches to createMemoryRouter when __ABYSS_PARCEL_BUILD__ is
// defined (set in vite.config.ts for config-system compatibility). A MemoryRouter keeps
// navigation purely in-memory, so the browser URL never updates on tab or route changes.
// Use createBrowserRouter directly so every navigate() call updates the browser URL.
const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <React.Fragment>
        <Routes />
        <ScrollRestoration />
      </React.Fragment>
    ),
  },
]);

export const browser = () => {
  return (
    <Provider store={store}>
      <AuthProvider>
        <I18nProvider>
          <OverlayProvider>
            <ThemeProvider theme={theme} includeBaseCss={false}>
              <RouterProvider router={router}>{null}</RouterProvider>
            </ThemeProvider>
          </OverlayProvider>
        </I18nProvider>
      </AuthProvider>
    </Provider>
  );
};
